import React from 'react';
import { Typography, Box } from '@mui/material';
import VideoWithTimeline from '../VideoWithTimeline';
import { useData } from '../DataProvider';

const VideoWithTimelineConnected = ({ filePath, runId = null, appInfo = null, viewConfig = {}, fullScreen = false }) => {
  const { seekTo, setCurrentVideoTime, allRows } = useData();
  
  const handleTimeUpdate = React.useCallback((time) => {
    setCurrentVideoTime(time);
  }, [setCurrentVideoTime]);
  
  return (
    <VideoWithTimeline
      src={filePath}
      seekTo={seekTo}
      onTimeUpdate={handleTimeUpdate}
      events={allRows}
      runId={runId}
      appInfo={appInfo}
      viewConfig={viewConfig}
      fullScreen={fullScreen}
    />
  );
};

const VideoPanel = ({ appInfo, runId = null, viewConfig = {}, fullScreen = false }) => {
  return (
    <>
      {appInfo?.video ? (
        <VideoWithTimelineConnected filePath={appInfo.video} runId={runId} appInfo={appInfo} viewConfig={viewConfig} fullScreen={fullScreen} />
      ) : (
        <Box 
          sx={{ 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'grey.50',
            border: '2px dashed',
            borderColor: 'grey.300',
            borderRadius: 1
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No video file available
          </Typography>
        </Box>
      )}
    </>
  );
};

export default VideoPanel;
